import { mensagemCampoObrigatorio } from '@core/util/mensagemUtil';
import * as yup from 'yup';

const TransferenciaSchema = yup
  .object()
  .shape({
    contaOrigemId: yup
      .string()
      .nullable()
      .required(mensagemCampoObrigatorio('a conta origem')),
    contaDestinoId: yup
      .string()
      .nullable()
      .required(mensagemCampoObrigatorio('a conta destino')),
    valor: yup
      .number()
      .nullable()
      .required(mensagemCampoObrigatorio('o valor'))
      .test('valor', mensagemCampoObrigatorio('o valor'), (valor) => {
        if (valor) return true;
        return false;
      }),
    data: yup
      .date()
      .nullable()
      .required(mensagemCampoObrigatorio('a data')),
  })
  .nullable();

export default TransferenciaSchema;
